// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3oPD_","errors":"Errors_errors__2qzco"};